exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".operations-catalog-container{width:100%;height:100%}.operations-catalog-frame{width:100%;height:100%!important;border:none;display:block}", ""]);

// exports
